import React from 'react'
import { CBadge, CCol, CFormLabel, CFormSelect, CRow } from '@coreui/react-pro'
import GamePrivacy from './GamePrivacy'
import InfoTooltip from './InfoTooltip'

const GameRulesSection = ({ values, onChange, gameData }) => (
  <CRow className="g-3">
    {/* <CCol md={6}>
      <CFormLabel className="fw-bold d-flex align-items-center">
        Game Visibility
        <InfoTooltip content="Default visibility of the game is set as 'Public'. If privacy is set as 'Private', all members will be required to enter the unique game code to join the game." />
        {Number(values.game_visibility) === 1 && (
          <CBadge color="success" className="ms-2">
            Recommended
          </CBadge>
        )}
      </CFormLabel>
      <GamePrivacy
        bare
        hideDescription
        value={values.game_visibility}
        onChange={(value) => onChange('game_visibility', value)}
        gameData={gameData}
      />
    </CCol> */}
    <CCol md={6}>
      <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="squad_alert">
        Squad Alert
        <InfoTooltip content="Notify members with an alert if their squad is incomplete or invalid before selections lock." />
      </CFormLabel>
      <CFormSelect
        id="squad_alert"
        name="squad_alert"
        value={values.squad_alert}
        onChange={(e) => onChange('squad_alert', e.target.value)}
      >
        <option value="0">No Squad Alerts</option>
        <option value="1">Show Squad Alerts</option>
      </CFormSelect>
    </CCol>
  </CRow>
)

export default GameRulesSection
